/**
 * takes top block of strata workflow and checks if a convergence block is present
 * if there isn't but there are indicators present then it will set an error that there
 * is a loose indicator block
 * @param {*} topBlock 
 */
function validateLooseBlocks(topBlock) {
    let descendants = topBlock.getDescendants();
    
    let convergenceCount = 0
    let indicatorCount = 0

    descendants.forEach(descendant => {
        if(descendant.type.includes('indicator')) {
            indicatorCount++;
        } else if (descendant.type === 'strata_convergence' || descendant.type === 'strata_predictive_convergence') {
            convergenceCount++;
        }
        descendant.setWarningText(null, "role_warning")
    })

    if(indicatorCount > 0 && convergenceCount === 0) {
        topBlock.setWarningText("Please attach indicator to a convergence block", "role_warning")
    }
}

/**
 * function to validate strata blocks
 * @param {*} topBlock 
 */
function validateStrataBlock(topBlock) {
    validateLooseBlocks(topBlock)
}

export {validateStrataBlock}